import React from 'react';
import {
  FDBodyText,
  FDPaper,
  FDPrimaryActionButton,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const GoalsPageControlPanel = ({
  goalsPageResource, prioritizing = false, onTogglePrioritizing = noop,
}) => {
  const { loadModalCollectionByLink } = useModalContext();
  const goals = goalsPageResource.attr('goals').resources().list() || [];
  const hasGoals = goals.length > 0;
  const hasMoreThanOneGoal = goals.length > 1;
  return (
    <FDPaper padding={4}>
      <FDStack direction={'column'} spacing={4} width={'100%'}>
        <FDBodyText value={'Change your mind on priority? Feel free to re-arrange now.'} />
        <FDStack direction={'column'} spacing={2} width={'100%'}>
          {hasGoals ? (
            <FDPrimaryActionButton label={prioritizing ? 'Save priority' : 'Re-prioritize goals'} onClick={() => onTogglePrioritizing()} disabled={!hasMoreThanOneGoal} />
          ) : (
            <FDBodyText size={'sm'} value={'It looks like you have no goals. Add one to get started.'} color={'textDisabled'} align={'center'} />
          )}
          {goalsPageResource.withRelationship(
            fr.relationships.addGoal.name,
            (rel) => <FDSecondaryActionButton label={'Add another goal'} disabled={prioritizing} onClick={() => loadModalCollectionByLink(rel.link('related').url())} />,
            () => null,
          )}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

GoalsPageControlPanel.propTypes = {
  goalsPageResource: PropTypes.instanceOf(fr.Resource).isRequired,
  prioritizing: PropTypes.bool,
  onTogglePrioritizing: PropTypes.func,
};

export { GoalsPageControlPanel };
